import { z } from 'zod/v4';
// Types of operational tasks
export const TaskTypeSchema = z.enum([
    'follow_up',
    'qa_review',
    'exception_handling',
    'document_review',
    'client_outreach',
    'other',
]);
// Task status workflow
export const TaskStatusSchema = z.enum([
    'pending',
    'in_progress',
    'completed',
    'cancelled',
]);
// Task priority levels aligned with business SLAs
export const TaskPrioritySchema = z.enum([
    'standard', // 3 business days (24 business hours)
    'priority', // Next business day (8 business hours)
    'urgent', // Same day (4 business hours)
    'on-demand', // Custom deadline - uses dueAt field directly
]);
export const TaskSchema = z.object({
    id: z.string().uuid(),
    type: TaskTypeSchema,
    status: TaskStatusSchema,
    priority: TaskPrioritySchema,
    title: z.string(),
    description: z.string().optional(),
    // Related entities (optional - task can be standalone or linked)
    orderId: z.string().uuid().optional(),
    filingId: z.string().uuid().optional(),
    caseId: z.string().uuid().optional(),
    // Assignment
    assigneeId: z.string().uuid().optional(),
    createdById: z.string().uuid(),
    // Timing
    dueAt: z.string().datetime().optional(),
    completedAt: z.string().datetime().optional(),
    // Timestamps
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateTaskSchema = TaskSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    completedAt: true,
});
export const UpdateTaskSchema = TaskSchema.partial().omit({
    id: true,
    createdById: true,
    createdAt: true,
});
